import businessModelsData from '../data/businessModels.json';
export const CATERING_BM_ID = 'bm2';
export const CARLS_JR_BM_ID = 'bm6';
export const BM20_ID = 'bm20';
export const SUNSET_BM_ID = 'bm100';
export const ONE_CLICK_TENANT_BM = 'bm100';
export const HARALD_NYBORG_BM_ID = 'bm600';
const BusinessModelMgr = Object.freeze({
    findAll() {
        return Object.values(businessModelsData);
    },
    findById(id) {
        return BusinessModelMgr.findAll().find((bm) => bm.id === id);
    },
});
export default BusinessModelMgr;
